import {useEffect} from 'react';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {COLORS, LED_SELECTORS} from '../floorplan/utils/consts';
import {DATAPOINT_BLINK_MAPPING, DATAPOINT_IS_ONLINE} from '../../../modules/common/consts';
import {clearAllBlinks, setColorAndFlashing} from '../../common/blinkHelpers';
import {WidgetSvg} from '../floorplan/hooks/types';
import {AssetLiveData} from '../common/useAssetSubscription';

const useDeviceColors = (
	asset: Asset | null | undefined,
	svgRootObj: WidgetSvg | undefined,
	assetLiveData: AssetLiveData,
	widgetKey: string
) => {
	useEffect(() => {
		if (svgRootObj && asset) {
			const {id: assetId} = asset;
			Object.keys(assetLiveData).forEach((datapointName) => {
				const dataPointValue = assetLiveData[datapointName];
				const elementSelector = LED_SELECTORS[datapointName];
				const elementToChange = svgRootObj.select(elementSelector);

				if (elementToChange) {
					if (datapointName === DATAPOINT_IS_ONLINE) {
						elementToChange.style('fill', dataPointValue ? COLORS.GREEN : COLORS.RED);
					} else if (DATAPOINT_BLINK_MAPPING[datapointName]) {
						setColorAndFlashing(
							assetId,
							elementToChange,
							DATAPOINT_BLINK_MAPPING[datapointName],
							dataPointValue,
							assetLiveData[DATAPOINT_BLINK_MAPPING[datapointName]],
							widgetKey
						);
					}
				}
			});
		}

		return () => {
			clearAllBlinks();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [assetLiveData]);
};

export default useDeviceColors;
